import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import DrawerChatgptInput from './DrawerChatgptInput';
import MenuGatilhos from './MenuGatilhos';
import Scrollbar from 'src/components/Scrollbar';
import {
    Sheet,
    SheetContent,
} from "src/@/components/ui/sheet"
import { Button } from 'src/@/components/ui/button';
import { Card } from 'src/@/components/ui/card';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { Label } from 'src/@/components/ui/label';
// ----------------------------------------------------------------------


export default function DrawerChatGpt({
    open,
    onClose,
    choice,
    textInputDrawer,
    isShowContextOptions,
    conversacao,
    changeText,
    onStartConversationGpt,
    onEnviarGpt,
    loadingGpt,
    onClear
}) {
    const { t } = useTranslation('chat');

    const [checked, setChecked] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedAction, setSelectedAction] = useState('resumir');
    const openMenu = Boolean(anchorEl);
    const messagesEndRef = useRef(null);
    const chatContainerRef = useRef(null);

    // Scroll automático para o final quando novas mensagens são adicionadas ou quando está carregando
    useEffect(() => {
        if (chatContainerRef.current) {
            const scrollToBottom = () => {
                if (chatContainerRef.current) {
                    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                }
            };

            // Pequeno delay para garantir que o DOM foi atualizado
            setTimeout(scrollToBottom, 50);
        }
    }, [conversacao, loadingGpt]);

    // Scroll quando o drawer abre
    useEffect(() => {
        if (open && chatContainerRef.current) {
            setTimeout(() => {
                if (chatContainerRef.current) {
                    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                }
            }, 300);
        }
    }, [open]);

    const quickActions = [
        {
            id: 'resumir',
            label: t('chatgpt.actions.summarize.label'),
            icon: 'mdi:file-document-outline',
            prompt: t('chatgpt.actions.summarize.prompt')
        },
        {
            id: 'elaborar',
            label: t('chatgpt.actions.reply.label'),
            icon: 'mdi:message-text-outline',
            prompt: t('chatgpt.actions.reply.prompt')
        },
        {
            id: 'sentimento',
            label: t('chatgpt.actions.sentiment.label'),
            icon: 'mdi:chart-bar',
            prompt: t('chatgpt.actions.sentiment.prompt')
        },
        {
            id: 'followup',
            label: t('chatgpt.actions.followup.label'),
            icon: 'mdi:arrow-right',
            prompt: t('chatgpt.actions.followup.prompt')
        },
        {
            id: 'urgencia',
            label: t('chatgpt.actions.urgency.label'),
            icon: 'mdi:alert-triangle-outline',
            prompt: t('chatgpt.actions.urgency.prompt')
        },
        {
            id: 'compliance',
            label: t('chatgpt.actions.compliance.label'),
            icon: 'mdi:shield-check-outline',
            prompt: t('chatgpt.actions.compliance.prompt')
        }
    ];

    const handleActionClick = (action) => {
        setSelectedAction(action.id);
        if (changeText && action.prompt) {
            changeText({
                target: {
                    value: action.prompt
                }
            });
        }
    };



    const ItemGerandoResposta = () => {
        return (
            <div className="flex flex-col gap-2 w-full animate-in fade-in duration-300">
                <div className="flex items-end gap-2">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-[#7C3AED]/10 text-[#7C3AED] ring-1 ring-[#7C3AED]/20 shrink-0 mb-1">
                        <Iconify icon="fluent:sparkle-24-filled" width={14} />
                    </div>
                    <Card className="p-3 bg-white border border-gray-100 shadow-sm rounded-2xl rounded-tl-sm">
                        <div className="flex items-center gap-3">
                            <div className="flex gap-1">
                                <span className="w-1.5 h-1.5 bg-[#7C3AED] rounded-full animate-[bounce_1s_infinite_0ms]" />
                                <span className="w-1.5 h-1.5 bg-[#7C3AED] rounded-full animate-[bounce_1s_infinite_200ms]" />
                                <span className="w-1.5 h-1.5 bg-[#7C3AED] rounded-full animate-[bounce_1s_infinite_400ms]" />
                            </div>
                            <span className="text-gray-500 text-xs font-medium">
                                {t('chatgpt.analyzing')}
                            </span>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }

    function handleClose() {
        onClear();
        onClose();

    }

    return (
        <Sheet open={open} onOpenChange={handleClose} >
            <SheetContent hideCloseButton={true} className="min-w-[60%] flex justify-between flex-col bg-white">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white/80 backdrop-blur-sm sticky top-0 z-10">
                    <div className="flex items-center gap-3">
                        <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#7C3AED]/10 text-[#7C3AED] ring-1 ring-[#7C3AED]/20">
                            <Iconify icon="fluent:sparkle-24-filled" width={22} />
                        </div>
                        <div className="flex flex-col gap-0.5">
                            <h2 className="text-gray-900 text-lg font-bold leading-none tracking-tight">Copilot</h2>
                            <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">{t('chatgpt.subtitle')}</span>
                        </div>
                    </div>
                    <div className="flex items-center gap-1">
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={onClear}
                            className="h-9 w-9 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200"
                            title={t('chatgpt.clearConversation')}
                        >
                            <Iconify icon="solar:trash-bin-minimalistic-linear" width={20} />
                        </Button>

                        <div className="h-4 w-px bg-gray-200 mx-1" />

                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={onClose}
                            className="h-9 w-9 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200"
                        >
                            <Iconify icon="mingcute:close-line" width={22} />
                        </Button>
                    </div>
                </div>

                <MenuGatilhos
                    open={openMenu}
                    anchorEl={null}
                    changeAnchorEl={() => setAnchorEl(null)}
                />

                <div className="flex-1 flex flex-col overflow-hidden">
                    <Scrollbar
                        sx={{
                            height: '100%',
                            '& .simplebar-content': {
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '16px'
                            }
                        }}
                    >
                        {/* Seção de Ações Rápidas */}
                        <div className="mb-6 px-1">
                            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 px-1">
                                {t('chatgpt.quickActions')}
                            </h3>
                            <div className="grid grid-cols-2 gap-3">
                                {quickActions.map((action) => (
                                    <button
                                        key={action.id}
                                        onClick={() => handleActionClick(action)}
                                        className={`
                                            group relative flex items-start gap-3 p-3 rounded-xl border text-left transition-all duration-200
                                            ${selectedAction === action.id
                                                ? 'bg-[#7C3AED]/5 border-[#7C3AED] shadow-sm ring-1 ring-[#7C3AED]/20'
                                                : 'bg-white border-gray-100 hover:border-[#7C3AED]/50 hover:shadow-md'
                                            }
                                        `}
                                    >
                                        <div className={`
                                            p-2 rounded-lg transition-colors duration-200 shrink-0 mt-0.5
                                            ${selectedAction === action.id
                                                ? 'bg-[#7C3AED] text-white'
                                                : 'bg-gray-50 text-gray-500 group-hover:bg-[#7C3AED]/10 group-hover:text-[#7C3AED]'
                                            }
                                        `}>
                                            <Iconify icon={action.icon} width={18} />
                                        </div>
                                        <div className="flex flex-col gap-0.5">
                                            <span className={`text-xs font-semibold transition-colors ${selectedAction === action.id ? 'text-[#7C3AED]' : 'text-gray-700 group-hover:text-gray-900'
                                                }`}>
                                                {action.label}
                                            </span>
                                            <span className="text-[10px] text-gray-400 leading-tight line-clamp-2">
                                                {action.prompt || t('chatgpt.defaultActionPrompt')}
                                            </span>
                                        </div>
                                        {selectedAction === action.id && (
                                            <div className="absolute top-2 right-2">
                                                <span className="flex h-2 w-2 rounded-full bg-[#7C3AED]" />
                                            </div>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Seção de Resultado */}
                        <div className="bg-gray-50/50 rounded-2xl border border-gray-100 flex-1 min-h-0 flex flex-col overflow-hidden relative">
                            <div
                                ref={chatContainerRef}
                                className="flex-1 overflow-y-auto scroll-smooth p-4"
                            >
                                {loadingGpt ? (
                                    <ItemGerandoResposta />
                                ) : conversacao && conversacao.length > 0 ? (
                                    <div className="flex flex-col gap-4 w-full pb-4">
                                        {conversacao.map((resposta, index) => {
                                            const isFromMe = resposta?.fromMe === true;
                                            return (
                                                <div
                                                    key={index}
                                                    className={`flex gap-3 w-full animate-in fade-in slide-in-from-bottom-2 duration-300 ${isFromMe ? 'flex-row-reverse' : 'flex-row'}`}
                                                >
                                                    {/* Avatar / Icon */}
                                                    <div className={`
                                                        flex items-center justify-center w-8 h-8 rounded-full shrink-0 shadow-sm
                                                        ${isFromMe
                                                            ? 'bg-gradient-to-br from-indigo-500 to-purple-600 text-white'
                                                            : 'bg-white border border-gray-100 text-[#7C3AED]'
                                                        }
                                                    `}>
                                                        <Iconify
                                                            icon={isFromMe ? "solar:user-bold" : "fluent:sparkle-24-filled"}
                                                            width={isFromMe ? 14 : 16}
                                                        />
                                                    </div>

                                                    <div className={`flex flex-col max-w-[85%] ${isFromMe ? 'items-end' : 'items-start'}`}>
                                                        <Card
                                                            className={`
                                                                border-0 shadow-sm px-4 py-3 text-sm relative break-words
                                                                ${isFromMe
                                                                    ? 'bg-[#7C3AED] text-white rounded-2xl rounded-tr-sm'
                                                                    : 'bg-white text-gray-700 rounded-2xl rounded-tl-sm border border-gray-100'
                                                                }
                                                            `}
                                                        >
                                                            <div className="leading-relaxed" dangerouslySetInnerHTML={{ __html: resposta?.body || '' }} />
                                                        </Card>
                                                        <span className="text-[10px] text-gray-400 mt-1 px-1">
                                                            {isFromMe ? t('header.you') : 'Copilot'}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div ref={messagesEndRef} />
                                    </div>
                                ) : (
                                    <div className="h-full flex flex-col items-center justify-center text-center p-8 opacity-60">
                                        <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4 text-gray-400">
                                            <Iconify icon="solar:chat-round-line-duotone" width={32} />
                                        </div>
                                        <p className="text-gray-900 font-medium text-sm mb-1">
                                            {t('chatgpt.emptyTitle')}
                                        </p>
                                        <p className="text-gray-500 text-xs max-w-[200px]">
                                            {t('chatgpt.emptyDescription')}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {isShowContextOptions && (
                            <div className="mt-4 px-1">
                                <label className="flex items-center gap-3 p-3 rounded-xl border border-gray-200 bg-gray-50/50 hover:bg-gray-50 hover:border-[#7C3AED]/30 transition-colors cursor-pointer group">
                                    <Checkbox
                                        id="context-checkbox"
                                        checked={checked}
                                        onCheckedChange={(checked) => setChecked(checked)}
                                        className="border-gray-300 data-[state=checked]:bg-[#7C3AED] data-[state=checked]:border-[#7C3AED] transition-all"
                                    />
                                    <div className="flex flex-col cursor-pointer">
                                        <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                                            {t('chatgpt.useContext')}
                                        </span>
                                        <span className="text-[10px] text-gray-500">
                                            {t('chatgpt.useContextHelp')}
                                        </span>
                                    </div>
                                </label>
                            </div>
                        )}
                    </Scrollbar>

                    <div className="mt-auto p-4 border-t border-gray-100 bg-white/50 backdrop-blur pb-8">
                        <DrawerChatgptInput
                            text={textInputDrawer}
                            changeText={changeText}
                            loadingGpt={loadingGpt}
                            onSend={onStartConversationGpt}
                        />
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
